// Menu des filtres d'options
const optionFiltersToggle = document.querySelector('.option-filters-toggle');
if (optionFiltersToggle) {
    const moreLessIcon = optionFiltersToggle.querySelector('.more-less');
    optionFiltersToggle.setAttribute('type', 'button');
    optionFiltersToggle.addEventListener('click', () => {
        if (moreLessIcon) {
            if (moreLessIcon.textContent === '-') {
                moreLessIcon.textContent = '+';
            } else {
                moreLessIcon.textContent = '-';
            }
        }

        const optionFilters = document.querySelector('.option-filters');
        if (optionFilters) {
            optionFilters.classList.toggle('option-filters--open');
        }
    });
}

// Filtres des produits
const productsFilter = document.querySelector('.products-filter');
const productsFilterOpenBtn = document.querySelector('.products-filter-toggle');
if (productsFilterOpenBtn && productsFilter) {
    productsFilterOpenBtn.addEventListener('click', () => {
        productsFilterOpenBtn.classList.toggle('open');
        productsFilter.classList.toggle('products-filter--open');
    });
}

// Filtres mobile
const productsFilterCloseBtn = document.querySelector('.products-filter-close');
const productsFilterOpenBtnMobile = document.querySelector('.products-filter-toggle-mobile');
if (productsFilterOpenBtnMobile && productsFilter) {
    productsFilterOpenBtnMobile.addEventListener('click', () => {
        productsFilter.classList.add('products-filter-mobile--open');
        document.body.classList.add('modale-filters-open');
    });

    if (productsFilterCloseBtn) {
        productsFilterCloseBtn.addEventListener('click', () => {
            productsFilter.classList.remove('products-filter-mobile--open');
            document.body.classList.remove('modale-filters-open');
        });
    }
}
